import { PropsWithChildren, ReactNode } from 'react';
import styles from './modal.module.scss';
import clsx from 'clsx';

interface Props {
  navBar?: ReactNode;
  title: ReactNode;
  'data-testid': string;
  fullWidth?: boolean;
}
export default function Modal(props: PropsWithChildren<Props>) {
  return (
    <div className={styles.Wrapper}>
      {props.navBar}
      <div
        className={clsx(styles.Container, props.fullWidth && styles.FullWidth)}
      >
        <h1 data-testid={props['data-testid'] + '-title'}>{props.title}</h1>
        {props.children}
      </div>
    </div>
  );
}
